/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { UseConfigContentSource_ContentSourceFragmentDoc } from './useContentSource.graphql';
import { UseConfigContentSource_ConfigFragmentDoc } from './useContentSource.graphql';
export type ChangeConfigDefaultContentSourceModal_ContentSourceSettingsFragment = { __typename: 'ConfigContentSourceSettings', available?: Array<{ __typename: 'ConfigAppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'ConfigBookmarkContentSource', index: number } | { __typename: 'ConfigInputContentSource', source: string } | { __typename: 'ConfigPlaylistContentSource', playlistId: string }> | null, current?: { __typename: 'ConfigContentSourceState', reported: { __typename: 'ConfigAppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'ConfigBookmarkContentSource', index: number } | { __typename: 'ConfigInputContentSource', source: string } | { __typename: 'ConfigPlaylistContentSource', playlistId: string } } | null, default?: { __typename: 'ConfigContentSourceState', reported: { __typename: 'ConfigAppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'ConfigBookmarkContentSource', index: number } | { __typename: 'ConfigInputContentSource', source: string } | { __typename: 'ConfigPlaylistContentSource', playlistId: string } } | null };

export type ChangeConfigDefaultContentSourceModal_ConfigFragment = { __typename: 'ConfigurationModel', id: string, supportsBootableContentSourceApps?: boolean | null, bookmarks: { __typename: 'ConfigBookmarks', all: { __typename: 'ConfigAllBookmarksState', reported?: Array<string> | null } }, contentSource?: { __typename: 'ConfigContentSourceSettings', default?: { __typename: 'ConfigContentSourceState', reported: { __typename: 'ConfigAppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'ConfigBookmarkContentSource', index: number } | { __typename: 'ConfigInputContentSource', source: string } | { __typename: 'ConfigPlaylistContentSource', playlistId: string } } | null, available?: Array<{ __typename: 'ConfigAppContentSource', label?: string | null, applicationId: string, isBootable?: boolean | null, activityList?: Array<string> | null, selectedActivity?: string | null } | { __typename: 'ConfigBookmarkContentSource', index: number } | { __typename: 'ConfigInputContentSource', source: string } | { __typename: 'ConfigPlaylistContentSource', playlistId: string }> | null, current?: { __typename: 'ConfigContentSourceState', reported: { __typename: 'ConfigAppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'ConfigBookmarkContentSource', index: number } | { __typename: 'ConfigInputContentSource', source: string } | { __typename: 'ConfigPlaylistContentSource', playlistId: string } } | null } | null, playlist?: { __typename: 'ConfigPlaylist', current?: { __typename: 'ConfigCurrentPlaylist', id: string, title: string } | null } | null };

export const ChangeConfigDefaultContentSourceModal_ContentSourceSettingsFragmentDoc = gql`
    fragment ChangeConfigDefaultContentSourceModal_contentSourceSettings on ConfigContentSourceSettings {
  available {
    ...UseConfigContentSource_contentSource
  }
  current {
    reported {
      ...UseConfigContentSource_contentSource
    }
  }
  default {
    reported {
      ...UseConfigContentSource_contentSource
    }
  }
}
    ${UseConfigContentSource_ContentSourceFragmentDoc}`;
export const ChangeConfigDefaultContentSourceModal_ConfigFragmentDoc = gql`
    fragment ChangeConfigDefaultContentSourceModal_config on ConfigurationModel {
  id
  supportsBootableContentSourceApps
  ...UseConfigContentSource_config
  bookmarks {
    all {
      reported
    }
  }
  contentSource {
    default {
      reported {
        ... on ConfigAppContentSource {
          label
          applicationId
        }
        ... on ConfigBookmarkContentSource {
          index
        }
        ... on ConfigInputContentSource {
          source
        }
        ... on ConfigPlaylistContentSource {
          playlistId
        }
      }
    }
    available {
      ... on ConfigAppContentSource {
        label
        applicationId
        isBootable
      }
      ... on ConfigBookmarkContentSource {
        index
      }
      ... on ConfigInputContentSource {
        source
      }
      ... on ConfigPlaylistContentSource {
        playlistId
      }
    }
  }
  playlist {
    current {
      id
      title
    }
  }
}
    ${UseConfigContentSource_ConfigFragmentDoc}`;